module.exports = __webpack_public_path__ + "img/o-childerns-waterpark.626f4d0d.jpg";